import React,{ useRef, useEffect, useState } from "react";

import { initialize } from "./ExtentChangeVM";

const ExtentChangeWidget = ({view}) => {
    const [isPrevDisabled, setPrevIsDisabled] = useState(false);
    const [isNextDisabled, setNextIsDisabled] = useState(false);
    const ExtentChangeWidgetDiv = useRef(null);
    const prevExtDiv = useRef(null);
    const nextExtDiv = useRef(null);

    useEffect(()=> {
        if (ExtentChangeWidgetDiv.current) {
          initialize(ExtentChangeWidgetDiv.current,setPrevIsDisabled,setNextIsDisabled,view,prevExtDiv.current,nextExtDiv.current)
            return() => {
              //ExtentChangeWidgetDiv.current.destroy()
            }
          }
      },[]) 

    return(
        <div ref={ExtentChangeWidgetDiv}>
          <div id="prevNextDiv" className="esri-component esri-widget">
            <button ref={prevExtDiv} id="prevExt" className="esri-widget--button esri-icon-left-triangle-arrow" title="Previous Extent" disabled={isPrevDisabled}></button>
            <button ref={nextExtDiv} id="nextExt" className="esri-widget--button esri-interactive esri-icon-right-triangle-arrow" title="Next Extent" disabled={isNextDisabled}></button>
          </div>
        </div>
      );
};

export default ExtentChangeWidget;